import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import iconAnimateTimer from 'assets/icons/animate/icon_animate_timer.svg';
const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
		},
	})
);

type LoadingModalProps = {
	showLoadingModal: boolean;
	isLongTime?: boolean;
};

export const LoadingModal = ({ showLoadingModal, isLongTime }: LoadingModalProps) => {
	const classes = useStyles();

	return (
		<Backdrop aria-disabled className={classes.backdrop} open={showLoadingModal}>
			{isLongTime ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						flexDirection: 'column',
						backgroundColor: 'rgb(255, 255, 255,1)',
						padding: '32px 16px',
						boxSizing: 'border-box',
						borderRadius: 8,
						margin: '0 16px',
						backdropFilter: 'blur(1px)',
					}}
				>
					<img src={iconAnimateTimer} alt="" />
					<h3 className="negro-general subtitle-1" style={{ marginTop: 32 }}>
						Espera unos segundos mientras calculamos el valor de tu cuota.
					</h3>
				</div>
			) : (
				<CircularProgress color="secondary" size={100} />
			)}
		</Backdrop>
	);
};
